import React, { useCallback } from 'react';

import People from '@atlaskit/icon/glyph/people';
import { openDialog } from 'src/services/jira';
import { useMyUserMapping } from 'src/services/myUserMapping';
import { useSession } from 'src/services/session';

import { locationReload } from 'src/lib/history';

const UserMappingButton = () => {
  const onClick = useCallback(() => {
    openDialog('/integration-jira-ui/issue_sidebar/modal_link_users', {
      width: '40vw',
      minHeight: 300,
      onClose: () => locationReload(),
    });
  }, []);
  const { loading, loggedIn } = useSession();
  const { warningMessages } = useMyUserMapping();
  if (loading) return null;
  if (!loggedIn) return null;

  return (
    <div className={`icon ${warningMessages.length === 0 ? '' : 'warn'}`} onClick={onClick} data-cy="sidebar-ui-users-button"><People/></div>
  );
};

export default UserMappingButton;
